module.exports = __webpack_public_path__ + "img/banner3.312c897b.png";